import { apiResponse } from 'api/api-response'
import { rootService } from 'api/api-root'
import { recordError } from 'tracing'
import _ from 'lodash'

export const apiDelete = async ({ token, data, url, onLogout = () => {} }) => {
  let headers
  let obj = apiResponse()

  if (token) {
    headers = {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  } else {
    headers = {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  }

  try {
    const res = await rootService.delete(`/${url}`, {
      headers,
      data
    })
    obj.resData = res.data
    obj.resStatus = res.status
    return obj
  } catch (error) {
    if (error.response.status === 401) {
      _.throttle(() => {
        onLogout()
      }, 3000)()
    }
    recordError(error, { 'http.operation': 'AXIOS DELETE' })
    obj.resData = error.response.data
    obj.resStatus = error.response.status
    return obj
  }
}
